import finEaseHomeNavigationRoutes from "./navigationRoutes";
import FinEaseHomePage from "../pages/FinEaseHomePage/Home";
import FinEaseAdmin from "../pages/FinEaseAdminPage";
import DashboardPage from "../pages/AdminFinEase/Dashboard";
import UserManagement from "../pages/AdminFinEase/UserManagement";
import NpsUserList from "../pages/AdminFinEase/Nps/NpsUserList";
import NpsUserDetails from "../pages/AdminFinEase/Nps/NpsUserDetails";
import UserAuditLogs from "../pages/AdminFinEase/Logs/UserAuditLogs";
import ApiIssueLogs from "../pages/AdminFinEase/Logs/ApiIssueLogs";
import LoginActivityLogs from "../pages/AdminFinEase/Logs/LoginActivityLogs";
import SmsLogs from "../pages/AdminFinEase/Logs/SmsLogs";
import PaymentManagementPage from "../pages/AdminFinEase/Nps/PaymentManagement/PaymentManagementPage";
import IPOManagement from "../pages/AdminFinEase/IPO/IPO Management";
import CreateIPOPage from "../pages/AdminFinEase/IPO/IPO Management/CreateIPOPage";
import NpsPage from "@/projects/FinEaseUser/pages/Nps/NpsPage";
import finEaseUserNavigationRoutes from "@/projects/FinEaseUser/utils/navigationRoutes";
import CompanyMasterList from "../pages/AdminFinEase/Screener/CompanyMaster/CompanyMasterList";
import IPOApplication from "../pages/AdminFinEase/IPO/IPO Application";
import AdminUserForm from "../pages/AdminFinEase/UserManagement/AddEditUser";
import GoldDashboard from "../pages/AdminFinEase/PhysicalGold/Dashboard";
import PricingControl from "../pages/AdminFinEase/PhysicalGold/PricingControl";
import ProductMaster from "../pages/AdminFinEase/PhysicalGold/ProductMaster";
import AddProductPage from "../pages/AdminFinEase/PhysicalGold/ProductMaster/AddProductPage";

import DeliveryMaster from "../pages/AdminFinEase/PhysicalGold/DeliveryMaster";
import CreateDeliveryMasterPage from "../pages/AdminFinEase/PhysicalGold/DeliveryMaster/CreateDeliveryMasterPage";

import GoldOrders from "../pages/AdminFinEase/PhysicalGold/Orders";
import OrderDetailsPage from "../pages/AdminFinEase/PhysicalGold/Orders/OrderDetailsPage";
import GoldSettlements from "../pages/AdminFinEase/PhysicalGold/Settlements";
import OperationLogs from "../pages/AdminFinEase/PhysicalGold/Logs";
import CommissionControl from "../pages/AdminFinEase/PhysicalGold/Commission";
import IPOMemberManagement from "../pages/AdminFinEase/IPO/Member Management";
import CreateMemberPage from "../pages/AdminFinEase/IPO/Member Management/CreateMemberPage";
import PastOrders from "../pages/AdminFinEase/IPO/Past Orders";
import IPOAllotmentList from "../pages/AdminFinEase/IPO/IPO Allotment";
import AllotmentDetails from "../pages/AdminFinEase/IPO/IPO Allotment/AllotmentDetails";
import BannersPage from "../pages/AdminFinEase/CMS/Banners";
import CreateBannerPage from "../pages/AdminFinEase/CMS/Banners/CreateBannerPage";
import HolidaysPage from "../pages/AdminFinEase/CMS/Holidays";
import CreateHolidayPage from "../pages/AdminFinEase/CMS/Holidays/CreateHolidayPage";
import SettlementDetailsPage from "../pages/AdminFinEase/PhysicalGold/Settlements/SettlementDetailsPage";
import ContactUsPage from "../pages/AdminFinEase/Products/ContactUsPage";
import CategoryMasterList from "../pages/AdminFinEase/Screener/CategoryMaster/CategoryMasterList";
import AddEditCategoryMaster from "../pages/AdminFinEase/Screener/CategoryMaster/AddEditCategoryMaster";
import QueryMasterAdminList from "../pages/AdminFinEase/Screener/QueryMasterAdmin/QueryMasterAdminList";
import AddEditQueryMasterAdmin from "../pages/AdminFinEase/Screener/QueryMasterAdmin/AddEditQueryMasterAdmin";
import QueryMasterUserList from "../pages/AdminFinEase/Screener/QueryMasterUser/QueryMasterUserList";
import AddEditQueryMasterUser from "../pages/AdminFinEase/Screener/QueryMasterUser/AddEditQueryMasterUser";
import QueryFieldMasterList from "../pages/AdminFinEase/Screener/QueryFieldMaster/QueryFieldMasterList";
import AddEditQueryFieldMaster from "../pages/AdminFinEase/Screener/QueryFieldMaster/AddEditQueryFieldMaster";
import RoleManagementRootRedirect from "../pages/AdminFinEase/RoleManagement";
import RoleManagementUsersPage from "../pages/AdminFinEase/RoleManagement/UsersPage";
import RoleManagementRolesPage from "../pages/AdminFinEase/RoleManagement/RolesPage";
import WebsiteLeadsPage from "../pages/AdminFinEase/Email/Website";

// Public routes that don't require authentication
const publicRoutes = [
  {
    path: finEaseHomeNavigationRoutes.FIN_EASE_HOME,
    element: FinEaseHomePage,
    name: "FinEase Home",
  },
  {
    path: finEaseHomeNavigationRoutes.ADMIN,
    element: FinEaseAdmin,
    name: "FinEase Admin",
  },
];

const authRoutes = [
  {
    path: finEaseHomeNavigationRoutes.ADMIN_DASHBOARD,
    element: DashboardPage,
    name: "Dashboard",
  },
  {
    path: finEaseHomeNavigationRoutes.USER_MANAGEMENT,
    element: UserManagement,
    name: "User Management",
  },
  {
    path: finEaseHomeNavigationRoutes.ADD_USER,
    element: AdminUserForm,
    name: "Add User",
  },
  {
    path: finEaseHomeNavigationRoutes.EDIT_USER_ROUTE,
    element: AdminUserForm,
    name: "Edit User",
  },
  {
    path: finEaseHomeNavigationRoutes.VIEW_USER_ROUTE,
    element: AdminUserForm,
    name: "View User",
  },
  {
    path: finEaseHomeNavigationRoutes.NPS_USER_LIST,
    element: NpsUserList,
    name: "Nps User List",
  },

  {
    path: finEaseHomeNavigationRoutes.NPS_USER_DETAILS_ROUTE,
    element: NpsUserDetails,
    name: "Nps User Details",
  },
  {
    path: finEaseHomeNavigationRoutes.ACTIVITY_LOG,
    element: UserAuditLogs,
    name: "Activity Log",
  },
  {
    path: finEaseHomeNavigationRoutes.USER_AUDIT_LOG,
    element: UserAuditLogs,
    name: "User Audit Logs",
  },
  {
    path: finEaseHomeNavigationRoutes.API_ISSUE_LOG,
    element: ApiIssueLogs,
    name: "API Issue Logs",
  },
  {
    path: finEaseHomeNavigationRoutes.LOGIN_ACTIVITY_LOG,
    element: LoginActivityLogs,
    name: "Login Activity Logs",
  },
  {
    path: finEaseHomeNavigationRoutes.SMS_ACTIVITY_LOG,
    element: SmsLogs,
    name: "SMS Activity Logs",
  },

  // Payment Entry Management
  {
    path: finEaseHomeNavigationRoutes.PAYMENT_ENTRY,
    element: PaymentManagementPage,
    name: "Payment Entry",
  },

  // IPO Management
  {
    path: finEaseHomeNavigationRoutes.IPO_PAST_ORDERS,
    element: PastOrders,
    name: "Past Orders",
  },
  {
    path: finEaseHomeNavigationRoutes.IPO_ALLOTMENT,
    element: IPOAllotmentList,
    name: "IPO Allotment",
  },
  {
    path: finEaseHomeNavigationRoutes.IPO_ALLOTMENT_DETAILS_ROUTE,
    element: AllotmentDetails,
    name: "IPO Allotment Details",
  },
  {
    path: finEaseHomeNavigationRoutes.IPO_MANAGEMENT,
    element: IPOManagement,
    name: "IPO Management",
  },
  {
    path: finEaseHomeNavigationRoutes.IPO_APPLICATION,
    element: IPOApplication,
    name: "IPO Application",
  },
  {
    path: finEaseHomeNavigationRoutes.IPO_MEMBER_MANAGEMENT,
    element: IPOMemberManagement,
    name: "IPO Member Management",
  },
  {
    path: finEaseHomeNavigationRoutes.CREATE_MEMBER,
    element: CreateMemberPage,
    name: "Create Member",
  },
  {
    path: finEaseHomeNavigationRoutes.EDIT_MEMBER_ROUTE,
    element: CreateMemberPage,
    name: "Edit Member",
  },
  {
    path: finEaseHomeNavigationRoutes.VIEW_MEMBER_ROUTE,
    element: CreateMemberPage,
    name: "View Member",
  },
  {
    path: finEaseHomeNavigationRoutes.CREATE_IPO,
    element: CreateIPOPage,
    name: "Create IPO",
  },
  {
    path: finEaseHomeNavigationRoutes.EDIT_IPO_ROUTE,
    element: CreateIPOPage,
    name: "Edit IPO",
  },
  {
    path: finEaseHomeNavigationRoutes.IPO_VIEW_ROUTE,
    element: CreateIPOPage,
    name: "IPO View",
  },
  {
    path: finEaseUserNavigationRoutes.NPS_OVERVIEW,
    element: NpsPage,
    name: "Nps Overview",
  },
  {
    path: finEaseUserNavigationRoutes.NPS_USER_LIST,
    element: NpsUserList,
    name: "Nps User List",
  },
  // Company Master List
  {
    path: finEaseHomeNavigationRoutes.COMPANY_MASTER_LIST,
    element: CompanyMasterList,
    name: "Company Master List",
  },
  {
    path: finEaseHomeNavigationRoutes.CATEGORY_MASTER,
    element: CategoryMasterList,
    name: "Category Master",
  },
  {
    path: finEaseHomeNavigationRoutes.CATEGORY_MASTER_ADD,
    element: AddEditCategoryMaster,
    name: "Category Master",
  },
  {
    path: finEaseHomeNavigationRoutes.CATEGORY_MASTER_EDIT_ROUTE,
    element: AddEditCategoryMaster,
    name: "Category Master",
  },
  {
    path: finEaseHomeNavigationRoutes.CATEGORY_MASTER_VIEW_ROUTE,
    element: AddEditCategoryMaster,
    name: "Category Master",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_ADMIN,
    element: QueryMasterAdminList,
    name: "Query Master Admin",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_ADMIN_ADD,
    element: AddEditQueryMasterAdmin,
    name: "Query Master Admin",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_ADMIN_EDIT_ROUTE,
    element: AddEditQueryMasterAdmin,
    name: "Query Master Admin",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_ADMIN_VIEW_ROUTE,
    element: AddEditQueryMasterAdmin,
    name: "Query Master Admin",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_USER,
    element: QueryMasterUserList,
    name: "Query Master User",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_USER_ADD,
    element: AddEditQueryMasterUser,
    name: "Query Master User",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_USER_EDIT_ROUTE,
    element: AddEditQueryMasterUser,
    name: "Query Master User",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_MASTER_USER_VIEW_ROUTE,
    element: AddEditQueryMasterUser,
    name: "Query Master User",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_FIELD_MASTER,
    element: QueryFieldMasterList,
    name: "Query Field Master",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_FIELD_MASTER_ADD,
    element: AddEditQueryFieldMaster,
    name: "Query Field Master",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_FIELD_MASTER_EDIT_ROUTE,
    element: AddEditQueryFieldMaster,
    name: "Query Field Master",
  },
  {
    path: finEaseHomeNavigationRoutes.QUERY_FIELD_MASTER_VIEW_ROUTE,
    element: AddEditQueryFieldMaster,
    name: "Query Field Master",
  },
  // Physical Gold
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_DASHBOARD,
    element: GoldDashboard,
    name: "Gold Dashboard",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_PRICE_CONTROL,
    element: PricingControl,
    name: "Pricing Control",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_PRODUCT_MASTER,
    element: ProductMaster,
    name: "Product Master",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_ADD_PRODUCT,
    element: AddProductPage,
    name: "Add Product",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_EDIT_PRODUCT_ROUTE,
    element: AddProductPage,
    name: "Edit Product",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_DELIVERY_MASTER,
    element: DeliveryMaster,
    name: "Delivery Master",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_ADD_DELIVERY_MASTER,
    element: CreateDeliveryMasterPage,
    name: "Add Delivery Master",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_EDIT_DELIVERY_MASTER_ROUTE,
    element: CreateDeliveryMasterPage,
    name: "Edit Delivery Master",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_VIEW_DELIVERY_MASTER_ROUTE,
    element: CreateDeliveryMasterPage,
    name: "View Delivery Master",
  },

  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_ORDERS,
    element: GoldOrders,
    name: "Gold Orders",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_EDIT_ORDER_ROUTE,
    element: OrderDetailsPage,
    name: "Edit Order",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_SETTLEMENTS,
    element: GoldSettlements,
    name: "Gold Settlements",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_SETTLEMENT_DETAILS_ROUTE,
    element: SettlementDetailsPage,
    name: "Settlement Details",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_ORDER_DETAILS_ROUTE,
    element: OrderDetailsPage,
    name: "Order Details",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_LOGS,
    element: OperationLogs,
    name: "Gold Operation Logs",
  },
  {
    path: finEaseHomeNavigationRoutes.PHYSICAL_GOLD_COMMISSION,
    element: CommissionControl,
    name: "Commission Control",
  },
  // CMS
  {
    path: finEaseHomeNavigationRoutes.CMS_BANNERS,
    element: BannersPage,
    name: "Banner Management",
  },
  {
    path: finEaseHomeNavigationRoutes.CREATE_CMS_BANNER,
    element: CreateBannerPage,
    name: "Create CMS Banner",
  },
  {
    path: finEaseHomeNavigationRoutes.EDIT_CMS_BANNER_ROUTE,
    element: CreateBannerPage,
    name: "Edit CMS Banner",
  },
  {
    path: finEaseHomeNavigationRoutes.VIEW_CMS_BANNER_ROUTE,
    element: CreateBannerPage,
    name: "View CMS Banner",
  },
  {
    path: finEaseHomeNavigationRoutes.CMS_HOLIDAYS,
    element: HolidaysPage,
    name: "Holidays",
  },
  {
    path: finEaseHomeNavigationRoutes.CREATE_CMS_HOLIDAY,
    element: CreateHolidayPage,
    name: "Create Holiday",
  },
  {
    path: finEaseHomeNavigationRoutes.EDIT_CMS_HOLIDAY_ROUTE,
    element: CreateHolidayPage,
    name: "Edit Holiday",
  },
  {
    path: finEaseHomeNavigationRoutes.CONTACT_QUERIES,
    element: ContactUsPage,
    name: "Contact Us",
  },
  {
    path: finEaseHomeNavigationRoutes.ROLE_MANAGEMENT,
    element: RoleManagementRootRedirect,
    name: "Role Management",
  },
  {
    path: finEaseHomeNavigationRoutes.ROLE_MANAGEMENT_USERS,
    element: RoleManagementUsersPage,
    name: "Role Management — Users",
  },
  {
    path: finEaseHomeNavigationRoutes.ROLE_MANAGEMENT_ROLES,
    element: RoleManagementRolesPage,
    name: "Role Management — Roles",
  },
  {
    path: finEaseHomeNavigationRoutes.EMAIL_WEBSITE_LEADS,
    element: WebsiteLeadsPage,
    name: "Website Leads",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: authRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
